import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  SelectChangeEvent,
} from "@mui/material";

interface ProductVariant {
  product_id: string;
  variant_specifics: Array<{ value: string }>;
}

interface ProductVariantSelectorProps {
  variants?: ProductVariant[];
  selectedVariantId?: string;
  onVariantChange: (event: SelectChangeEvent<string>) => void;
  isLoading: boolean;
}

export const ProductVariantSelector = ({
  variants,
  selectedVariantId,
  onVariantChange,
  isLoading,
}: ProductVariantSelectorProps) => {
  if (!variants || variants.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="body2"
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "text.secondary",
          mb: 1,
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        {isLoading ? "Loading..." : "Select Option"}
      </Typography>
      <FormControl fullWidth>
        <Select
          labelId="variant-select"
          id="variant-select"
          value={selectedVariantId || ""}
          onChange={onVariantChange}
          disabled={isLoading}
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#d0d0d0",
              borderWidth: 1.5,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main",
              borderWidth: 2,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main",
              borderWidth: 2,
            },
            "& .MuiSelect-select": {
              padding: "10px 14px",
              fontSize: 14,
              fontWeight: 500,
            },
            opacity: isLoading ? 0.7 : 1,
            transition: "opacity 0.2s ease-in-out",
          }}
        >
          {variants.map(({ product_id, variant_specifics }) => (
            <MenuItem
              key={product_id}
              value={product_id}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                padding: "8px 14px",
              }}
            >
              {variant_specifics.map(({ value }) => value).join(" - ")}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
